if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.mainButton = document.getElementById(this.dataset.mainButtonId);
        this.stickyButton = this.querySelector('[data-sticky-submit]');
        this.stickyLabel = this.querySelector('[data-sticky-button-label]');
        this.stickyPrice = this.querySelector('[data-sticky-price]');
        this.priceSource = document.getElementById(`price-${this.sectionId}`);

        if (!this.mainButton || !this.stickyButton) return;

        this.stickyButton.addEventListener('click', () => this.mainButton.click());
        this.observeMainButton();
        this.observeProductState();
        this.syncState();
      }

      disconnectedCallback() {
        this.visibilityObserver?.disconnect();
        this.stateObserver?.disconnect();
      }

      observeMainButton() {
        this.visibilityObserver = new IntersectionObserver(
          ([entry]) => {
            const hasPassedButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.toggleAttribute('hidden', !hasPassedButton);
          },
          { threshold: 0 }
        );
        this.visibilityObserver.observe(this.mainButton);
      }

      observeProductState() {
        this.stateObserver = new MutationObserver(() => this.syncState());
        this.stateObserver.observe(this.mainButton, {
          attributes: true,
          attributeFilter: ['disabled', 'class'],
          childList: true,
          subtree: true,
        });

        if (this.priceSource) {
          this.stateObserver.observe(this.priceSource, { childList: true, subtree: true });
        }
      }

      syncState() {
        this.stickyButton.disabled = this.mainButton.disabled;

        const mainLabel = this.mainButton.querySelector('span');
        if (mainLabel && this.stickyLabel) {
          this.stickyLabel.textContent = mainLabel.textContent.trim();
        }

        const activePrice =
          this.priceSource?.querySelector('.price__sale .price-item--sale') ||
          this.priceSource?.querySelector('.price__regular .price-item--regular');

        if (activePrice && this.stickyPrice) {
          this.stickyPrice.textContent = activePrice.textContent.trim();
        }
      }
    }
  );
}
